export default (theme) => ({
    root: {
        width: '100%',
    },
    stepsContainer: {
        width: '100%',
        display: 'flex',
        flexFlow: 'row nowrap',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
    },
    stepItem: {
        position: 'relative',
        display: 'flex',
        flex: 1,
        alignItems: 'center',
        '&:last-child': {
            flex: 'none',
        },
    },
    stepContent: {
        display: 'flex',
        flexFlow: 'row nowrap',
        alignItems: 'center',
        position: 'relative',
        zIndex: 1,
    },
    icon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 32,
        height: 32,
        borderRadius: '50%',
        color: theme.colors.textLight.secondary,
        backgroundColor: theme.colors.primary.white,
        border: '1px solid',
        borderColor: theme.colors.grey[100],
        flexShrink: 0,
    },
    iconHighlighted: {
        backgroundColor: theme.colors.actionMajor[500],
        borderColor: theme.colors.transparent,
        color: theme.colors.primary.white,
        cursor: 'pointer',
        '& *': {
            color: theme.colors.primary.white,
        },
    },
    label: {
        marginLeft: 8,
        marginRight: 8,
        position: 'relative',
        wordBreak: 'break-all',
    },
    labelClickable: {
        cursor: 'pointer',
    },
    connector: {
        flex: 1,
        height: 1,
        backgroundColor: theme.colors.grey[100],
    },
    connectorCompleted: {
        backgroundColor: theme.colors.actionMajor[500],
    },
    connectorActive: {
        background: `linear-gradient(to right, ${theme.colors.actionMajor[500]} 50%, ${theme.colors.grey[100]} 50%)`,
    },
});
